import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-24fbeff4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  role: "tabpanel",
  class: "tab-pane data-panel",
  id: "data"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "nav nav-pills" }, [
  /*#__PURE__*/_createElementVNode("li", { class: "active" }, [
    /*#__PURE__*/_createElementVNode("a", {
      "data-toggle": "tab",
      href: "#profile"
    }, "Profile")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      "data-toggle": "tab",
      href: "#licence",
      "data-test": "org-licence-overview"
    }, "Subscription overview")
  ])
], -1))
const _hoisted_3 = { class: "tab-content" }
const _hoisted_4 = {
  id: "profile",
  class: "tab-pane fade in active"
}
const _hoisted_5 = { style: {"margin":"2rem 0"} }
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]
const _hoisted_8 = ["href"]
const _hoisted_9 = ["href"]
const _hoisted_10 = {
  id: "licence",
  class: "tab-pane fade"
}

import { computed } from "vue";
import { OrganisationAndMembersApiModel } from "../../../api-models";
import SubscriptionOverview from "./subscription-overview.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'data-tab',
  props: {
    model: {}
  },
  emits: ["revalidate-org-data"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const scratchpadLink = computed(() => {
  const url = new URL("/scratchpad", window.location.origin);
  url.searchParams.set("subject", "Org");
  url.searchParams.set("id", props.model.id.toString());
  return url.href;
});

const revalidateOrgData = () => {
  emit("revalidate-org-data");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", null, [
            _createElementVNode("a", {
              href: `/admin/crmexport/orgdata/${_ctx.model.id}`,
              "data-test": "gd-data-export-link"
            }, "Data Export", 8, _hoisted_6)
          ]),
          _createElementVNode("p", null, [
            _createElementVNode("a", {
              href: '/organisation/heatmap/' + _ctx.model.id,
              target: "_blank",
              rel: "noopener noreferrer"
            }, "Organisation Heatmap", 8, _hoisted_7)
          ]),
          _createElementVNode("p", null, [
            _createElementVNode("a", {
              href: '/organisation/report/' + _ctx.model.id,
              target: "_blank",
              rel: "noopener noreferrer"
            }, "View Organisation Report", 8, _hoisted_8)
          ]),
          _createElementVNode("p", null, [
            _createElementVNode("a", {
              href: scratchpadLink.value,
              "data-test": "org-scratchpad-link"
            }, "Go to scratchpad ✨", 8, _hoisted_9)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(SubscriptionOverview, {
          subscriptions: _ctx.model.subscriptions,
          onRevalidateOrgData: revalidateOrgData
        }, null, 8, ["subscriptions"])
      ])
    ])
  ]))
}
}

})